module.exports = function getResource(label, vars = []) {
    const resources = {
        accept: 'J’accepte les',
        termsConditions: 'modalités de Sephora',
        mustAcceptTermsConditions: 'Vous devez d’abord accepter les conditions.',
        buttonCTAEnrolled: 'Déjà inscrit',
        buttonCTAEnrollNow: 'S’inscrire',
        flashTermsModalTitle: 'Conditions générales de Flash'
    };
    return resources[label];
};
